import * as React from 'react';
import LocalDiv from '../../localization/LocalDiv';
import { FLEX_ROW } from '../../layout/flexBox';
import { css } from '@emotion/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser, faCheck } from '@fortawesome/free-solid-svg-icons';
import Spacer from '../../layout/Spacer';
import { Requirement } from '../models';
import { COLORS } from '../../globalStyle/colors';


type Props = {
  className?: string;
  title?: string;
  requirement: Requirement;
  showMaximum: boolean;
  spacerSize?: number;
};


/**
 * RequirementMenuItem: a component that displays the required minimum (and, if applicable, maximum) number of raters
 * for a given rater level, similarly to the `RequirementsSummary` rows in the project dashboard.
 *
 * PureComponent: true
 * Redux Connected: false
 */
const RequirementMenuItem: React.FC<Props> = props => {
  const isComplete = props.requirement.raterCount >= props.requirement.minimumRequired;
  const maxString  = props.showMaximum ? `-${props.requirement.maximumRequired}` : '';
  const spacerSize = props.spacerSize || 8;

  return (
    <LocalDiv
      css={[css`color: ${isComplete ? COLORS.BLUE : COLORS.DARK_GREY};`, props.className]}
      title={props.title}
    >
      <LocalDiv css={[FLEX_ROW, css`margin: 10px;`]}>
        <FontAwesomeIcon icon={faUser} size='lg' />
        <Spacer sizePx={spacerSize} />
        <span>{`${props.requirement.minimumRequired}${maxString} ${props.requirement.fullName}`}</span>
        <Spacer sizePx={spacerSize} />
        {isComplete && <FontAwesomeIcon icon={faCheck} size='lg' />}
      </LocalDiv>
    </LocalDiv>
  );
};

export default RequirementMenuItem;
